import { render, staticRenderFns } from "./RenewalButton.vue?vue&type=template&id=31ef1dca&scoped=true"
import script from "./RenewalButton.vue?vue&type=script&lang=ts"
export * from "./RenewalButton.vue?vue&type=script&lang=ts"
import style0 from "./RenewalButton.vue?vue&type=style&index=0&id=31ef1dca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef1dca",
  null
  
)

export default component.exports